/**
 * Merges an array of refs into a single ref
 *
 * Inspired by https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (!ref)
                return;
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}

export { mergeRefs };
//# sourceMappingURL=refs.esm.js.map
